"use client";

import React from "react";
import Typography from "@sendsprint/ui-react/components/typography";
import { formatDate } from "@/utils/formatDate";

interface Props {
  date: string | undefined;
}

const BlogDate = ({ date }: Props) => {
  const blogDate = formatDate(date || "");
  return (
    <Typography as="p" variant="paragraphSmall" className="ss-text-center">
      {blogDate}
    </Typography>
  );
};

export default BlogDate;
